<script lang="ts" setup>
/**
 * ユーザー情報。
 */

import { defineProps } from "vue";
import { CommunityTalkUserViewModel } from "@/viewModels/communityTalk/communityTalkUserViewModel";
import CommunityTalkUserNickNameProfilePic from "@/components/communityTalk/CommunityTalkUserNickNameProfilePic.vue";
import CommunityTalkUserReviewerAttributeAnswer from "@/components/communityTalk/CommunityTalkUserReviewerAttributeAnswer.vue";
import ReplyBadge from "@/components/communityTalk/reply/ReplyBadge.vue";
import CommunityTalkNewArrivalBadge from "./CommunityTalkNewArrivalBadge.vue";

interface Props {
	/**
	 * コミュニティトークユーザー情報。
	 */
	viewModel: CommunityTalkUserViewModel;

	/**
	 * 投稿日時。
	 */
	postDate: string;

	/**
	 * 新着投稿バッジ文言
	 */
	newArrivalBadgeText: string;

	/**
	 * 新着投稿バッジ表示日数
	 */
	newArrivalBadgeDisplayDays: number;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<div class="revico-community-talk-details-user">
		<div class="revico-community-talk-details-user-left">
			<!-- リプライバッジ -->
			<ReplyBadge :badgeType="viewModel.badgeType" />
		</div>
		<div class="revico-community-talk-details-user-right">
			<CommunityTalkUserNickNameProfilePic :nick-name="viewModel.nickName" :profile-pic-url="viewModel.profilePicUrl" />
			<CommunityTalkNewArrivalBadge :post-date="postDate" :new-arrival-badge-display-days="newArrivalBadgeDisplayDays" :new-arrival-badge-text="newArrivalBadgeText" />
			<CommunityTalkUserReviewerAttributeAnswer :reviewer-attribute-answers="viewModel.reviewerAttributeAnswers" />
		</div>
	</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-details-user {
		display: flex;
		width: 100%;
		margin-bottom: 8px;
		position: relative;

		&-left + &-right {
			margin-left: 8px;
		}
	}
}
</style>
